/* eslint-disable one-var */
/* eslint-disable no-nested-ternary */
/* eslint-disable prefer-destructuring */
/* eslint-disable prefer-template */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/jsx-boolean-value */
import React, { useContext, useEffect, useState } from 'react';
import {
  CellClickedEvent,
  ColDef,
  ColGroupDef,
  GridApi,
  GridOptions,
} from 'ag-grid-community';
import { useTheme } from '@material-ui/core/styles';
import { LicenseManager } from 'ag-grid-enterprise';
import { AgGridReact } from 'ag-grid-react';
import { AgGridTableWrapperOffset } from '@mummssoftware/common-ui';
import { dateToYYYYMMDD } from '@mummssoftware/utils/dates';
import { TaskGlobalContext } from '@mummssoftware/global-context/TaskGlobalContext';
import { Popover } from '@material-ui/core';
import { NoteCountCellRenderer, TaskWeekCellRenderer } from './CellRenderer';
import { getColumnDefs } from './PatientTableColumnDef';

import 'ag-grid-community/dist/styles/ag-grid.css';
import '@mummssoftware/common-ui/style/css/ag-theme-hummingbird.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import {
  allXdaysInRange,
  weekStartDatesToGroupedColumns,
  withWeekMap,
} from './utils';
import { DetailsModal } from './DetailsModal';
import { PatientAssistanceContext } from '../../context';
import { AssistanceContext } from '../Context/AssistanceContext';

LicenseManager &&
  LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_KEY as string);

interface PatientAssistanceTableProps {
  viewModePrint?: boolean;
  smallWidget?: boolean;
}

const frameworkComponents = {
  noteCountCellRenderer: NoteCountCellRenderer,
  weekCellRenderer: TaskWeekCellRenderer,
};

const getCellContainer = (cell: Element) => cell.closest('.ag-cell') as any;

const getCellWeekDataFromClickEvent = (e: CellClickedEvent) => {
  const { data, colDef } = e as any;
  return data.weeks[colDef.key];
};

const extractCellStyles = (cell: any) => ({
  color: cell.style.color,
  backgroundColor: cell.style.backgroundColor,
});

const applyCellStyles = (cellStyles: any, cell: any) => {
  cell.style.color = cellStyles.color;
  cell.style.backgroundColor = cellStyles.backgroundColor;
};

export const PatientAssistanceTable = ({
  viewModePrint,
  smallWidget,
}: PatientAssistanceTableProps) => {
  const {
    props: { grid: gridTheme },
  } = useTheme() as any;
  const [gridApi, setGridApi] = useState<GridApi | null>(null);
  const [selectedCell, setSelectedCell] = useState<null | Element>(null);
  const [selectedCellData, setSelectedCellData] = useState<null | any>(null);
  const [selectedCellStyles, setSelectedCellStyles] = useState<any>(null);

  const { patient, currentUser } = useContext(PatientAssistanceContext);
  const { fromDate, toDate, includeRefused } = useContext(AssistanceContext);
  const { weeklyTasks } = useContext(TaskGlobalContext);

  let rowData,
    weekStartDates,
    weekColumnSchema = [] as any;

  if (weeklyTasks && fromDate && toDate) {
    const byEffectiveDate = [...weeklyTasks].sort((a, b) =>
      (a.effectivedate || '').localeCompare(b.effectivedate || ''),
    );
    rowData = byEffectiveDate.map(withWeekMap);
    weekStartDates = allXdaysInRange(
      currentUser.startOfWeek || 'SUNDAY',
      fromDate,
      toDate,
    ).map(dateToYYYYMMDD);
    weekColumnSchema = weekStartDatesToGroupedColumns(weekStartDates);
  }

  const haveWeeksToShow = weekColumnSchema && weekColumnSchema.length;

  const columnDefs = getColumnDefs(!!patient, !!smallWidget, weekColumnSchema);

  const getLastColumn = (colDefs: ColDef[]): ColDef => {
    const lastMonths = (colDefs[colDefs.length - 1] as ColGroupDef).children;
    const lastWeeks = (lastMonths[lastMonths.length - 1] as ColGroupDef)
      .children;
    return lastWeeks[lastWeeks.length - 1];
  };

  const onGridReady = async (params: any) => {
    setGridApi(params.api);
    // gridApi.sizeColumnsToFit();
    // @strategy for PRINT to work!
    if (gridApi) {
      if (viewModePrint) {
        (gridApi as any).setDomLayout('print');
      }
    }
  };

  const gridOptions: GridOptions = {
    defaultColDef: {
      resizable: false,
      filter: 'agTextColumnFilter',
      menuTabs: ['filterMenuTab'],
    },
    columnDefs,
    masterDetail: !smallWidget,
    detailRowAutoHeight: true,
    onGridReady,
  };

  useEffect(() => {
    if (gridApi) {
      // todo breaks on opening detail modal
      gridApi.setColumnDefs([{}]);
      gridApi.setColumnDefs(columnDefs);
      if (haveWeeksToShow) {
        const lastColumn = getLastColumn(weekColumnSchema);
        gridApi.ensureColumnVisible(lastColumn.colId as string);
      }
    }
  }, [gridApi, JSON.stringify(columnDefs)]);

  const deselectSelectedCell = () => {
    applyCellStyles(selectedCellStyles, selectedCell);
    setSelectedCell(null);
    setSelectedCellData(null);
  };

  // only selectable if it has tasks (extra logic for isolating completed tasks given includeRefused value)
  const isCellSelectable = (cellData: any) =>
    cellData ? includeRefused || cellData.weektotal : false;

  const selectCell = (e: CellClickedEvent) => {
    if (selectedCell) {
      deselectSelectedCell();
    }
    const cell = getCellContainer(e.event?.target as any);
    const cellData = getCellWeekDataFromClickEvent(e);

    if (isCellSelectable(cellData)) {
      setSelectedCell(cell);
      setSelectedCellData(getCellWeekDataFromClickEvent(e));
      setSelectedCellStyles(extractCellStyles(cell));
      cell.style.color = 'white';
      cell.style.backgroundColor = '#005880';
    }
  };

  return (
    <>
      <Popover
        open={selectedCell && selectedCellData}
        anchorEl={selectedCell}
        onClose={deselectSelectedCell}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <DetailsModal task={selectedCellData} />
      </Popover>

      <AgGridTableWrapperOffset
        id="patient-assistance-table-wrapper"
        className={`${gridTheme.className} light`}
        printMode={viewModePrint}
        smallWidget={smallWidget}
      >
        <AgGridReact
          gridOptions={gridOptions}
          rowData={rowData as mumms.WeekSummaryTaskRow[] | undefined}
          rowHeight={gridTheme.rowHeight}
          headerHeight={gridTheme.headerHeight}
          frameworkComponents={frameworkComponents}
          animateRows
          onGridReady={onGridReady}
          onCellClicked={(e) => {
            selectCell(e);
          }}
        />
      </AgGridTableWrapperOffset>
    </>
  );
};
